<template>
<div>
  我是消息
  <router-link to="/c1/c11">111</router-link>
  <br/>


  <router-link to="/c1/c12">2223s</router-link>


  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "c1"
}
</script>

<style scoped>

</style>